import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faNewspaper, faPlusCircle, faSearch, faUser, faWallet } from '@fortawesome/free-solid-svg-icons';
import './index.css';

const Footer = () => (
    <div className="bottom-menu">
        <div className='outFooter'></div>
        <div className="menu">
            <NavLink to="/" exact activeClassName="active">
                <div className="icon">
                    <FontAwesomeIcon icon={faMobileAlt} />
                </div>
                <div className="text">Apps</div>
            </NavLink>
            <NavLink to="/news" activeClassName="active">
                <div className="icon">
                    <FontAwesomeIcon icon={faNewspaper} />
                </div>
                <div className="text">News</div>
            </NavLink>
            <NavLink to="/add-app" activeClassName="active">
                <div className="icon">
                    <FontAwesomeIcon icon={faPlusCircle} />
                </div>
                <div className="text">Add App</div>
            </NavLink>
            <NavLink to="/search" activeClassName="active">
                <div className="icon">
                    <FontAwesomeIcon icon={faSearch} />
                </div>
                <div className="text">Search</div>
            </NavLink>
            <NavLink to="/account" activeClassName="active">
                <div className="icon">
                    <FontAwesomeIcon icon={faUser} />
                </div>
                <div className="text">Account</div>
            </NavLink>
        </div>
    </div>
);

export default Footer;